import React from 'react';
import { Button, Modal, ModalHeader } from 'reactstrap';
import IntlMessages from 'util/IntlMessages';
import FormErrors from 'components/formErrors/FormErrors';
import { isNameValid } from 'services/Validation';

class BusinessUnitAdd extends React.Component {
    constructor(props) {
        super(props);

        const { id, orgid, thumb, name, description, selected, starred, frequently } = props.businessUnit;
        this.state = {
            id,
            orgid,
            thumb,
            name,
            description,
            selected,
            starred,
            frequently,
            nameValid: isNameValid(name),
            formErrors: { name: '' },
            formValid: false,
        };
    }

    componentDidMount() {
        this.validateForm();
    }

    handleUserInput = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        this.setState(
            { [name]: value },
            () => { this.validateField(name, value); } // run this call back on state change
        );
    }

    validateField(fieldName, value) {
        let fieldValidationErrors = this.state.formErrors;
        let nameValid = this.state.nameValid;

        switch (fieldName) {
            case 'name':
                nameValid = isNameValid(value);
                fieldValidationErrors.name = nameValid ? '' : ' is invalid';
                break;
            default:
                break;
        }
        this.setState({
            formErrors: fieldValidationErrors,
            nameValid: nameValid,
        }, this.validateForm);
    }

    validateForm() {
        this.setState({ formValid: this.state.nameValid });
    }

    render() {
        const { onSaveBusinessUnit, showBusinessUnitLoader, onBusinessUnitClose, open, businessUnit } = this.props;
        const { id, orgid, name, description, selected, starred, frequently } = this.state;
        const isNew = businessUnit.name === '';
        let { thumb } = this.state;
        return (
            <Modal className="modal-box" toggle={onBusinessUnitClose} isOpen={open}>
                <ModalHeader className="modal-box-header bg-primary">
                    {isNew ? <IntlMessages id="businessUnit.addBusinessUnit" /> :
                        <IntlMessages id="businessUnit.saveBusinessUnit" />}
                    <span className="text-white pointer">
                        <i className="zmdi zmdi-close zmdi-hc-lg" onClick={onBusinessUnitClose} />
                    </span>
                </ModalHeader>

                <div className="modal-box-content">
                    <div className="row no-gutters">
                        <div className="col-lg-3 text-center text-lg-right order-lg-2">
                            <img id="thumb" className="ml-lg-3 mb-4 mb-lg-0 avatar size-120" src={thumb} />
                        </div>

                        <div className="panel panel-default">
                            <FormErrors formErrors={this.state.formErrors} />
                        </div>

                        <div className="col-lg-9 d-flex flex-column order-lg-1">
                            <h3 className="card-heading">{<IntlMessages id="label.name" />}</h3>
                            <input id="name" type="text" className={`form-control mb-2 ${name ? 'is-valid' : 'is-invalid'}`}
                                onChange={(event) => this.handleUserInput(event)}
                                defaultValue={name} name="name"
                            />
                            <h3 className="card-heading">{<IntlMessages id="label.description" />}</h3>
                            <input id="description" type="text" className="form-control mb-2"
                                onChange={(event) => this.handleUserInput(event)}
                                defaultValue={description} name="description"
                            />
                        </div>
                    </div>
                </div>

                <div className="modal-box-footer d-flex flex-row">
                    <Button className="text-uppercase" disabled={!this.state.formValid} color="primary" onClick={() => {
                        showBusinessUnitLoader();
                        onBusinessUnitClose();
                        onSaveBusinessUnit(
                            {
                                'id': id,
                                'orgid': orgid,
                                'name': name,
                                'description': description,
                                'thumb': thumb,
                                'selected': selected,
                                'starred': starred,
                                'frequently': frequently,
                            });
                        this.setState({
                            id: '',
                            orgid: '',
                            name: '',
                            description: '',
                            thumb: null,
                            selected: false,
                            starred: false,
                            frequently: false,
                            formErrors: { name: '' },
                            formValid: false,
                        });

                    }}>
                        {isNew ? <IntlMessages id="businessUnit.addBusinessUnit" /> :
                            <IntlMessages id="businessUnit.saveBusinessUnit" />}</Button>
                </div>
            </Modal>
        );
    }
}

export default BusinessUnitAdd;


// WEBPACK FOOTER //
// ./components/Agile/businessUnit/businessUnitAdd/index.js